import { useQuery } from '@tanstack/react-query'

import { getTfaAppQRCode } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks/use-axios'

export const useFetchTfaAppQRCode = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })
  axiosInstance.defaults.responseType = 'arraybuffer'
  const { data, isError, isLoading } = useQuery({
    queryFn: () => getTfaAppQRCode(axiosInstance),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_TFA_APP_QR_CODE],
  })
  return { data, isError, isLoading }
}
